import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListSources } from "../../../components/Admin/Sources";
import { useLanguage } from "../../../contexts";
import "./Sources.scss";

export function Sources() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const panes = [
    {
      menuItem: t("active_sources"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListSources sourcesActive={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_sources"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListSources sourcesActive={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="sources-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="sources-page-header-wrapper">
        <div className="sources-page-header">
          <span className="sources-page-title">{translations.sources}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
